import * as React from 'react';
import {Navigate} from 'react-router-dom';
import {useSelector} from 'react-redux';
import {selectAuthUser} from 'store/selectors';

/**
 * Server-side (Api::V1 guard) is the real enforcement - this only stops a
 * guest (anonymous marketplace-preview user) from seeing a page shell whose
 * data calls will 403 anyway.
 */
export const GuestRestricted = ({children}: { children: React.ReactNode }) => {
    const authUser = useSelector(selectAuthUser);

    if (authUser?.account_role === 'guest') {
        return <Navigate to="/notFound" replace/>;
    }

    return <>{children}</>;
};
